import { Pipe, PipeTransform } from '@angular/core';
import { CategoryModel } from '@shared-models/shared-models.module';

@Pipe({
    name: 'categoryName',
    standalone: false
})
export class CategoryNamePipe implements PipeTransform {

    transform(value: string): string {
        switch (value) {
            case CategoryModel.tennis.code:
                return CategoryModel.tennis.name;
            case CategoryModel.squash.code:
                return CategoryModel.squash.name;
            case CategoryModel.pickleball.code:
                return CategoryModel.pickleball.name;
            case CategoryModel.racquetball.code:
                return CategoryModel.racquetball.name;
        }
    }

}
